import type { SearchCriteria } from '@/entities/searchCriteria';
import type { PromoPlacement } from '@/shared/di';
import { A51_PLACEMENT_TYPE, MOBWEB_PLACEMENT_MARKER } from '../config/a51';

export function getPromoPlacementType(placementId: string): string {
  return placementId.split('.')[2]?.toLowerCase() ?? '';
}

function isMobwebPromoPlacement(placement: PromoPlacement): boolean {
  return placement.placementId.includes(MOBWEB_PLACEMENT_MARKER);
}

export function getPlatformPromoPlacements(
  placements: readonly PromoPlacement[],
  isMobileDomain: boolean,
): readonly PromoPlacement[] {
  if (!isMobileDomain) {
    return placements.filter((placement) => !isMobwebPromoPlacement(placement));
  }

  const mobwebPlacements = placements.filter((placement) => isMobwebPromoPlacement(placement));

  return mobwebPlacements.length > 0 ? mobwebPlacements : placements;
}

function getSearchCountryId({ destination }: SearchCriteria): number | null {
  return destination && destination.kind !== 'none' ? destination.country.id : null;
}

export function findA51Placement(
  placements: readonly PromoPlacement[],
  searchCriteria: SearchCriteria,
  isMobileDomain: boolean,
): PromoPlacement | null {
  const countryId = getSearchCountryId(searchCriteria);

  if (countryId === null) {
    return null;
  }

  return (
    getPlatformPromoPlacements(placements, isMobileDomain).find(
      (placement) =>
        Number(placement.countryId) === countryId &&
        getPromoPlacementType(placement.placementId) === A51_PLACEMENT_TYPE,
    ) ?? null
  );
}
